import { Injectable } from '@angular/core';
import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { CellActionTypes } from '../../../tables/components/cell-actions.type';
import { SuggestedUser } from '../../relation-request.interface';
import { UserSearchTableConstructor } from '../search-table';

export const suggestedUserRowData: (user: SuggestedUser) => GridTableBody = (user: SuggestedUser) => {
  return {
    entityId: user.user.user_id,
    actorId: user.user.user_id,
    user: user.user,
    manage: { status: Boolean(user.connectionDetails), reason: user.connectionDetails?.status },
    created: '',
    tooltipValues: { [CellActionTypes.ADD]: 'TOOLTIP_SEND_REQUEST' },
  };
};

@Injectable()
export class SuggestedUserTable implements UserSearchTableConstructor {
  public buildTableData(items: SuggestedUser[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manageRelation', key: 'manage' };
  }

  private getTableBody(items: SuggestedUser[]): GridTableBody[] {
    return items.map(suggestedUserRowData);
  }
}
